/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import LocalStorageSurvey from "../localStorage/survey.localStorage";
import type {
  Survey,
  SurveyQuestion,
  SurveyQuestionPagination,
  SurveysAnswer,
} from "../../../domain/survey/survey.types";

export interface SurveyState {
  isFinish: boolean;
  isLoadingSurveys: boolean;
  isLoadingSurvey: boolean;
  isLoadingQuestion: boolean;
  surveys: Array<Survey>;
  surveyQuestion: SurveyQuestion | null;
  surveysAnswers: SurveysAnswer;
  surveyPagination: SurveyQuestionPagination;
}

export const surveyInitialState: SurveyState = {
  isFinish: false,
  isLoadingSurveys: false,
  isLoadingSurvey: false,
  isLoadingQuestion: false,
  surveys: [],
  surveyQuestion: null,
  surveysAnswers: {},
  surveyPagination: {
    next: 0,
    prev: 0,
    order: 0,
    total: 0,
  },
};

const slice = createSlice({
  name: "SurveyState",
  initialState: surveyInitialState,
  reducers: {
    setSurveys: (state, action: PayloadAction<Array<Survey>>) => {
      state.surveys = action.payload;
    },

    setSurveyQuestion: (state, action: PayloadAction<SurveyQuestion>) => {
      state.surveyQuestion = action.payload;
    },
    setSurveysLoading: (state) => {
      state.isLoadingSurveys = true;
    },
    setEndSurveysLoading: (state) => {
      state.isLoadingSurveys = false;
    },
    setSurveyLoading: (state) => {
      state.isLoadingSurvey = true;
    },
    setEndSurveyLoading: (state) => {
      state.isLoadingSurvey = false;
    },
    setQuestionsLoading: (state) => {
      state.isLoadingQuestion = true;
    },
    setEndQuestionsLoading: (state) => {
      state.isLoadingQuestion = false;
    },
    setAnswersFromLocalStorage: (
      state,
      action: PayloadAction<SurveysAnswer>,
    ) => {
      state.surveysAnswers = { ...action.payload };
    },
    setSurveyIsFinish: (state) => {
      state.isFinish = true;
    },
    setAnswerBySurvey: (
      state,
      action: PayloadAction<{
        survey_id: string;
        question_id: string;
        answers_ids: string[];
      }>,
    ) => {
      const newSurveyAnswers = {
        ...state.surveysAnswers,
        [action.payload.survey_id]: {
          ...state.surveysAnswers[action.payload.survey_id],
          [action.payload.question_id]: action.payload.answers_ids,
        },
      };
      state.surveysAnswers = newSurveyAnswers;
      LocalStorageSurvey.setAnswers(newSurveyAnswers);
    },
    setSurveyPagination: (
      state,
      action: PayloadAction<SurveyQuestionPagination>,
    ) => {
      state.surveyPagination = action.payload;
    },
  },
});

export const {
  setSurveys,
  setSurveyQuestion,
  setSurveyIsFinish,
  setSurveysLoading,
  setEndSurveysLoading,
  setEndSurveyLoading,
  setSurveyLoading,
  setEndQuestionsLoading,
  setQuestionsLoading,
  setAnswerBySurvey,
  setAnswersFromLocalStorage,
  setSurveyPagination,
} = slice.actions;

export default slice.reducer;
